import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import BaseStore from '../base_store';
import EventBus from '~/event/bus';
import OrganizationUserSelect from '~/bundles/organization_users/components/ou_user_select';
import CellPopoverList from '~/components/vuetable/components/cell_popover_list';
import ImageUploadCropper from '~/components/image_crop/components/image_crop_form_wrap';
import CharacterCounter from '~/components/character_counter/components/character_counter';
import { initializeComponents } from '~/utils/bundle_utils';
import '~/directives/focus_input';
import '~/directives/analytics';
import BotsplashProvider from '~/bundles/communications/components/botsplash';

Vue.config.errorHandler = (err, vm, info) => {
  console.error('Vue error:', err, info);
};

if (process.env.NODE_ENV !== 'production') {
  Vue.config.productionTip = false;
}

Vue.use(Vuetify, {
    theme: {
        primary: '#348fe2',
        secondary: '#b6c2c9',
        accent: '#b6c2c9',
        error: '#ff5b57',
        info: '#49b6d6',
        success: '#00acac',
        warning: '#f59c1a',
    },
    iconfont: 'fa4',
});

window.vueShared = {
    mountComponents: mountComponents,
    baseStore: BaseStore,
    eventBus: EventBus,
};

function mountComponents() {
    initializeComponents('.vue-organization-user-select', OrganizationUserSelect);
    initializeComponents('.vue-cell-popover-list', CellPopoverList);
    initializeComponents('.vue-image-crop', ImageUploadCropper);
    initializeComponents('.vue-char-counter', CharacterCounter);
}

$(() => {
    mountComponents();

    let el = document.getElementById('botsplash-provider');

    if (!el) {
        el = document.createElement('div');
        el.id = 'botsplash-provider';
        document.body.appendChild(el);
    }
    try {
    new Vue({
        render: (h) => h(BotsplashProvider),
    }).$mount(el);
    } catch (err) {
        console.error('Botsplash mount failed:', err);
    }
});
